import { Injectable } from '@angular/core';
import { MvpHttpClient } from "../../../mvp-auth";
import { MicrosecRequestSchema } from '../../model/microsecRequestSchema';
@Injectable({
  providedIn: 'root'
})
export class MicrosecService {

  constructor(private readonly http: MvpHttpClient) { }

  microsecStartSignaturePost$(context: MicrosecRequestSchema){
    return this.http.post<any>(`/dms/signature/start`, context);
  }

  microsecCheckSignatureStatusGet$(sessionId: string){
    return this.http.get<any>(`/dms/signature/status/${sessionId}`);
  }
}
